export const faqList = [
  {
    q: "本站的「当季新番」包含哪些内容？",
    a: "首页把当季新番推荐、热门排行、放送日历与资讯整合在一起。推荐区按题材标签筛选，排行区提供人气、评分、期待三个维度，放送日历按周一到周日列出更新时间，方便你规划追番节奏。",
  },
  {
    q: "番剧表里的更新时间是准确的吗？",
    a: "番剧表按常见的每周放送习惯整理，用于帮助安排观看节奏。不同平台的更新可能存在时间差，实际以各作品官方公布的信息为准。",
  },
  {
    q: "标签筛选会不会改变页面内容？",
    a: "不会。筛选只作用于本页已有的推荐卡片，用于缩小范围，不会跳转到其他页面，也不会重新加载数据，因此切换很快、也不影响其他分区。",
  },
  {
    q: "人气榜和评分榜有什么区别？",
    a: "人气榜侧重讨论热度与观看规模的综合表现，评分榜更看重作品完成度与口碑。两者可以结合看：交集越多的作品，通常越值得优先跟。",
  },
  {
    q: "期待榜是做什么用的？",
    a: "期待榜用于安排下一阶段的候补名单。它反映的是作品在播出或定档前的关注度，适合提前把想追的作品加进清单，避免开播后错过。",
  },
  {
    q: "内容会定期更新吗？",
    a: "页面会围绕当季新番持续整理推荐、排行与资讯内容。若你希望固定追踪某类题材，可以先用标签筛选锁定范围，再定期回来看放送日历的变化。",
  },
];